module.exports = __webpack_public_path__ + "img/footer_wx.66d4f88e.svg";